import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../views/Layout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录', public: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '数据看板' }
      },
      {
        path: 'product',
        name: 'Product',
        component: () => import('../views/Product.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'order',
        name: 'Order',
        component: () => import('../views/Order.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'afterSale',
        name: 'AfterSale',
        component: () => import('../views/AfterSale.vue'),
        meta: { title: '售后管理' }
      },
      {
        path: 'comment',
        name: 'Comment',
        component: () => import('../views/Comment.vue'),
        meta: { title: '评价管理' }
      },
      {
        path: 'pay',
        name: 'Pay',
        component: () => import('../views/Pay.vue'),
        meta: { title: '支付管理' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/User.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('../views/Coupon.vue'),
        meta: { title: '优惠券管理' }
      },
      // 系统设置：下拉里的每一项都是独立页面
      { path: 'setting', redirect: '/setting/siteinfo' },
      {
        path: 'setting/siteinfo',
        name: 'SettingSiteInfo',
        component: () => import('../views/Setting.vue'),
        meta: { title: '系统信息' }
      },
      {
        path: 'setting/banner',
        name: 'SettingBanner',
        component: () => import('../views/Banner.vue'),
        meta: { title: '首页轮播' }
      },
      {
        path: 'setting/pay',
        name: 'SettingPay',
        component: () => import('../views/Setting.vue'),
        meta: { title: '支付设置' }
      },
      {
        path: 'setting/service',
        name: 'SettingService',
        component: () => import('../views/Setting.vue'),
        meta: { title: '客服设置' }
      },
      {
        path: 'setting/recharge',
        name: 'SettingRecharge',
        component: () => import('../views/Setting.vue'),
        meta: { title: '充值配置' }
      },
      {
        path: 'setting/member',
        name: 'SettingMember',
        component: () => import('../views/Setting.vue'),
        meta: { title: '会员政策' }
      },
      {
        path: 'setting/adminUser',
        name: 'SettingAdminUser',
        component: () => import('../views/AdminUser.vue'),
        meta: { title: '账号管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 当前登录管理员角色（登录/刷新资料后写入 localStorage）
function adminRole() {
  try {
    return JSON.parse(localStorage.getItem('adminUser') || '{}').role || ''
  } catch (e) {
    return ''
  }
}

// 全局守卫：未登录跳登录；系统设置（含账号管理）超级管理员与演示账号可进入
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken')
  if (to.meta.public) {
    next()
  } else if (!token) {
    next('/login')
  } else if (to.path.startsWith('/setting') && adminRole() && !['super', 'demo'].includes(adminRole())) {
    // 普通账号不能访问系统设置
    next('/dashboard')
  } else {
    next()
  }
})

export default router
